/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, memo, MouseEvent as ReactMouseEvent } from 'react';
import { HeaderMegaMenuData } from '../../page-frame-types/HeaderMegaMenuData';
import { NoDataAvailable } from '../../page-frame-types/NoDataAvailable';
import { HEADER_VERSIONS } from '../../constants';
import { HeaderLink } from '../../page-frame-types/HeaderLink';
import { HeaderLinkDescription } from '../../page-frame-types/HeaderLinkDescription';
import { ZillowNavbarSectionList } from './components/ZillowNavbarSectionList';
import { ZillowNavbarSection } from './components/ZillowNavbarSection/ZillowNavbarSection';

export type ZillowNavbarLinksContainerProps = {
    links: HeaderMegaMenuData | NoDataAvailable;
    zhlHost: string;
    version: HEADER_VERSIONS;
    useVerticalMegaMenu?: boolean;
    onLinkClick?: (
        link: HeaderLink | HeaderLinkDescription,
        event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
};

export const ZillowNavbarSections: FunctionComponent<ZillowNavbarLinksContainerProps> = memo(
    ({ links, zhlHost, version, useVerticalMegaMenu = false, onLinkClick }) => {
        if (!links) {
            return null;
        }
        const { sections } = links;
        return (
            <>
                <ZillowNavbarSectionList>
                    {sections.map(section => (
                        <ZillowNavbarSection
                            onLinkClick={onLinkClick}
                            version={version}
                            zhlHost={zhlHost}
                            useVerticalMegaMenu={useVerticalMegaMenu}
                            section={section}
                            key={section.link.text}
                        />
                    ))}
                </ZillowNavbarSectionList>
            </>
        );
    }
);
